// Red shoe next to a booking's time slot when it came in on a free-footwear offer.
const FREE_FOOTWEAR_CODES = ['CLAIM-FREE-FOOTWEAR', 'HALLOSHOE'];

export function isFreeFootwear(code) {
  return FREE_FOOTWEAR_CODES.includes((code || '').trim().toUpperCase());
}

export default function FreeShoeIcon({ code }) {
  if (!isFreeFootwear(code)) return null;
  return (
    <svg viewBox="0 0 24 24" className="inline-block w-4 h-4 ml-1 align-text-bottom text-red-600" fill="currentColor"
      role="img" aria-label="Free footwear offer">
      <title>{`Free footwear offer (${(code || '').trim().toUpperCase()})`}</title>
      <path d="M2 16.6V9.5C2 8.7 2.7 8 3.5 8H6c1 0 1.6 1.6 3 1.6 1 0 1.4-2.6 2.3-2.6l1.2.4 6.5 4.6c2 1 3 2 3 3.5v1.1z" />
      <path d="M1.5 17.4h21v1.1c0 .8-.7 1.5-1.5 1.5H3c-.8 0-1.5-.7-1.5-1.5z" />
      <path d="M13 9.2l1.3-.9M14.8 10.5l1.3-.9M16.6 11.8l1.3-.9" stroke="#fff" strokeWidth=".9" strokeLinecap="round" />
    </svg>
  );
}
